import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const StyledBox = styled(Box)`
  text-align: center;
  img {
    margin-bottom: 30px;
  }
  h2 {
    margin-bottom: 26px;
  }
  h6 {
    margin-bottom: 46px;
  }
  button {
    margin-bottom: 40px;
  }
`;
